import { createReducer, on } from "@ngrx/store"
import * as payrollActions from './payroll.actions';

export interface PayrollState {
    createPayrollLoading: boolean;
    updatePayrollLoading: boolean;

    allPayrolls: [] | null;
    payrollsError: boolean;
    payrollsLoading: boolean;

    singlePayroll: [] | null;
    singlePayrollError: boolean;
    singlePayrollLoading: boolean;
}

export const initialState: PayrollState = {
    createPayrollLoading: false,
    updatePayrollLoading: false,

    allPayrolls: null,
    payrollsError: null,
    payrollsLoading: null,

    singlePayroll: null,
    singlePayrollError: null,
    singlePayrollLoading: null,
}

export const PayrollsReducer = createReducer(
    initialState,

    on(payrollActions.createPayroll, (state) => ({
        ...state, createPayrollLoading: true
    })),

    on(payrollActions.createPayrollSuccess, (state) => ({
        ...state, createPayrollLoading: false,
    })),

    on(payrollActions.createPayrollFailed , (state) => ({
        ...state, createPayrollLoading: false
    })),

    on(payrollActions.updatePayroll, (state) => ({
        ...state, updatePayrollLoading: true
    })),

    on(payrollActions.updatePayrollSuccess, (state) => ({
        ...state, updatePayrollLoading: false,
    })),

    on(payrollActions.updatePayrollFailed , (state) => ({
        ...state, updatePayrollLoading: false
    })),

    on(payrollActions.fetchPayrolls, (state) => ({
        ...state, allPayrolls: null, payrollsError: null, payrollsLoading: true
    })),

    on(payrollActions.fetchPayrollsSuccess, (state, {payrolls}) => ({
        ...state, allPayrolls: payrolls, payrollsError: false, payrollsLoading: false
    })),

    on(payrollActions.fetchPayrollsFailed, (state) => ({
        ...state, allPayrolls: null, payrollsError: true, payrollsLoading: false
    })),

    on(payrollActions.fetchPayroll, (state) => ({
        ...state, singlePayroll: null, singlePayrollError: null, singlePayrollLoading: true
    })),

    on(payrollActions.fetchPayrollSuccess, (state, {payroll}) => ({
        ...state, singlePayroll: payroll, singlePayrollError: false, singlePayrollLoading: false
    })),

    on(payrollActions.fetchPayrollFailed, (state) => ({
        ...state, singlePayroll: null, singlePayrollError: true, singlePayrollLoading: false
    })),


)